function NoPermissions() {
  return (
    <div>
      <p>You don't have permission to view this page.</p>
    </div>
  );
}

export default NoPermissions;
